
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn
             color="primary"
             :class="{ 'float-right': floatRight, 'mr-2': true }"
             v-bind="props"><v-icon class="mr-2">mdi-plus</v-icon> A pagar</v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" :title="(modelValue?.invoice?.id ? 'Editar' : 'Novo') + ' lançamento a pagar'">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormBill
                  :user="user"
                  v-model="modelValue.invoice"
                  @created="createdObject"
                  @updated="updatedObject"
                  @writeoff="writeoff" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormBill from "./FormBill.vue";
export default {
  components: { FormBill },
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  emits: ["update:modelValue", "created", "updated", "writeoff"],
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
    createdObject(val) {
      this.dialog = false;
      this.$emit("created", val);
    },
    updatedObject(val) {
      this.dialog = false;
      this.$emit("updated", val);
    },
    writeoff(val) {
      this.dialog = false;
      this.$emit("writeoff", val);
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal?.invoice?.id && !this.dialog) {
        if (!newVal.invoice.hasOwnProperty('cashflow_category')) {
          newVal.invoice['cashflow_category'] = newVal.invoice.categories[0];
        }
        this.dialog = true;
      }
    },
    dialog(newVal) {
      if (!newVal) {
        this.value = {
          invoice: {
            type: this.$INVOICE_TYPE_DIC.BILL.value
          }
        };
      }
    },
  },
};
</script>
